<script setup>
import {onMounted} from "vue";
import {globalEnums} from "@/services/globalEnums.ts";
import Toast from "primevue/toast";

// redydratatie van de toepassing: als je op 'reload' klikt dan behoud je niet alleen je sessie
// maar ook de lookups uit de backend
onMounted(async () => {
    globalEnums.setup();
    console.log('.............EN DE HELE MIC MAC IS GEINITIALISEERD!');
})

</script>

<template>
    <Toast />
    <router-view/>
</template>

<style scoped>

</style>
